export { CanvasAbout as About } from './CanvasAbout/CanvasAbout';
export { CanvasHome as Home } from './CanvasHome/CanvasHome';
export { CanvasServices as Services } from './CanvasServices/CanvasServices';
export { CanvasPortfolio as Portfolio } from './CanvasPortfolio/CanvasPortfolio';
export { CanvasTeam as Team } from './CanvasTeam/CanvasTeam';
export { CanvasContact as Contact } from './CanvasContact/CanvasContact';
export { CanvasPackages as Packages } from './CanvasPackages/CanvasPackages';
